import { useEffect, useState } from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
import { Link, useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import * as qs from "qs";
import Students from "../../commonpage/Students";
import {
  handleItemsPerPageChange,
  handlePageChange,
} from "../../utils/PaginationUtilities";

export default function ManagePeople({ title }) {
  const [selectedStudents, setSelectedStudents] = useState([]);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const isOpen = useSelector((state) => state.modal.isOpen);
  const [status, setStatus] = useState(true);
  const { batchId } = useParams();
  const [peoples, setPeoples] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const userId = sessionStorage.getItem("userId");
  useEffect(() => {
    if (!isOpen) {
      dispatch(showLoader());
      ApiServices.apiRequest("getAssignStudent", { batchId: batchId })
        .then((res) => {
          if (res.data.success) {
            let allData = res.data.data;
            let filterStatus = status === "true" || status === true;
            let filterData = allData?.map((el) => {
              return {
                ...el,
                students: el.students.filter(
                  (e) => e.studentstatus === filterStatus
                ),
              };
            });
            setTotalData(res.data.total || 0);
            setTotalPages(Math.ceil(res.data.total / itemsPerPage));
            setPeoples(filterData);
            console.log("students in batch:", filterData);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err?.message ? err?.message : "Something went wrong");
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    }
  }, [isOpen, status, batchId, dispatch]);

  const changeStatusStudent = (id, studentId, status) => {
    let data = {
      _id: id,
      studentId: studentId,
      studentstatus: !status,
      status: !status,
    };
    dispatch(
      showModal(
        "StatusModal",
        data,
        "changeStatusAssignStudent",
        status ? "removeStudent" : "addBackStudent"
      )
    );
  };

  const handleCheckboxChange = (studentId) => {
    setSelectedStudents((prevSelected) => {
      if (prevSelected.includes(studentId)) {
        return prevSelected.filter((id) => id !== studentId);
      } else {
        return [...prevSelected, studentId];
      }
    });
  };

  const removeBulkPeople = () => {
    let data = {
      studentIds: JSON.stringify(selectedStudents),
      batchId: batchId,
    };
    dispatch(showModal("StatusModal", data, "bulkStudentRemove", "blockMulti"));
  };

  return (
    <>
      <div className="container">
        <div className="page-inner">
          {loading && !isOpen ? (
            <Loader />
          ) : (
            <>
              <div className="pt-2 pb-4">
                <h3 className="fw-bold mb-3">{title}</h3>
                <div className="d-flex justify-content-between">
                  <div>
                    {status ? (
                    <div className="dropdown">
                      <button
                        className="btn btn-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Actions
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={removeBulkPeople}
                          >
                            Remove
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  </div>
                  <div className="d-flex justify-content-end w-50">
                    <select
                      className="form-select me-2 w-25"
                      onChange={(e) => {
                        setStatus(e.target.value === "true");
                      }}
                      value={String(status)}
                    >
                      <option value="true">Current</option>
                      <option value="false">Removed</option>
                    </select>
                    <button
                      onClick={() => {
                        dispatch(showModal("AssignStudent"));
                      }}
                      className="btn btn-primary btn-round"
                    >
                      Add Student
                    </button>
                  </div>
                </div>
              </div>
              <Students
                peoples={peoples}
                totalData={totalData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange(setCurrentPage)}
                handleItemsPerPageChange={handleItemsPerPageChange(
                  setItemsPerPage,
                  setCurrentPage
                )}
                handleCheckboxChange={handleCheckboxChange}
                status={status}
                changeStatusStudent={changeStatusStudent}
                batchId={batchId}
                selectedStudents={selectedStudents}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}
